/** This is a temporary file, to move all overrides made for the toolbox
 * lately (e.g. collections, forms) in one central location before we
 * can convert them to canoe components
 * The purpose of this is to easily transition everything that uses these
 * ugly overrides later without too many conflicts or side-effects
 */

import { css, styled, TextInput } from 'canoe';

import Toggle from './Toggle';
import ValueBox from './ValueBox';

export const StyledToggle = styled(Toggle)<{
  isActive?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  standalone?: boolean;
  variant?: 'default' | 'collections';
  responsiveWidth?: boolean;
}>`
  ${({ theme, isActive, isFirst, isLast, standalone, variant, responsiveWidth }) => css`
    ${responsiveWidth &&
    css`
      width: auto;
    `}
    ${variant === 'collections' &&
    css`
      background-color: ${theme.colors.GlitterGrayL30};
      border-color: ${theme.colors.GlitterGray};

      > svg {
        stroke: ${theme.colors.GlitterGrayD10};
        fill: ${theme.colors.GlitterGrayD10};
      }

      & > span,
      &:hover > span {
        color: ${theme.colors.OnyxGrayL20};
      }
    `}
    &:last-of-type {
      border-right: 0 none;
      border-radius: 0 ${theme.borderRadius.small} ${theme.borderRadius.small} 0;
    }

    ${isActive &&
    css`
      ${variant === 'collections' &&
      css`
        background-color: ${theme.colors.MangoOrange};

        > svg {
          stroke: ${theme.colors.OnyxGrayD10};
          fill: ${theme.colors.OnyxGrayD10};
        }

        & > span,
        &:hover > span {
          color: ${theme.colors.GlitterGrayL30};
        }
      `}
    `}

    ${!standalone &&
    css`
      // in the middle of other fields (above/below),
      // only the right-most toggle
      &:last-of-type {
        ${!isFirst &&
        !isLast &&
        css`
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        `}

        ${isLast &&
        css`
          border-top-right-radius: 0;
        `}
      }

      ${isActive &&
      css`
        &:last-of-type {
          ${isFirst &&
          css`
            border-bottom-right-radius: 0;
          `}
        }
      `}
    `}
  `}
`;

export const StyledValueBox = styled(ValueBox)<{
  isActive?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  standalone?: boolean;
}>`
  ${({ theme, isActive, isFirst, isLast, standalone }) => css`
    max-width: 100%;
    flex: 1;
    background-color: ${theme.colors.GlitterGrayL20};
    border-color: ${theme.colors.GlitterGray};
    border-radius: ${theme.borderRadius.small};
    color: ${theme.colors.OnyxGray};

    ${!standalone &&
    css`
      ${!isFirst &&
      css`
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        ${!isLast &&
        css`
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom-color: transparent;
        `}
      `}

      ${isActive &&
      css`
        ${isFirst &&
        css`
          border-bottom: 0 none;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `}
      `}
    `}
  `}
`;

export const StyledTextInput = styled(TextInput)<{
  hasError?: boolean;
  prefix?: string;
  standalone?: boolean;
  variant?: 'default' | 'collections';
  isFirst?: boolean;
  isLast?: boolean;
}>`
  ${({ theme, hasError, prefix, standalone, variant, isFirst, isLast }) => css`
    height: 32px;
    font-size: ${theme.fonts.small.fontSize};
    border-color: ${theme.colors.GlitterGray};
    box-shadow: none;

    &:hover,
    &:focus {
      box-shadow: none;
      border-color: ${theme.colors.GlitterGrayD20};
    }

    ${
      prefix &&
      css`
        padding-left: ${theme.spaces.xxs};

        + label {
          height: 32px;
          font-size: ${theme.fonts.small.fontSize};
          padding: ${theme.spaces.xxs} ${theme.spaces.xs} ${theme.spaces.xxs} ${theme.spaces.xs};
        }
      `
    }

    ${
      variant !== 'collections' &&
      css`
        ${prefix &&
        css`
          + label {
            font-weight: ${theme.fontWeights.normal};
            background-color: ${theme.colors.GlitterGrayL20};
          }
        `}
      `
    }

    ${
      !standalone &&
      css`

        ${
          prefix &&
          css`
            + label {
              ${isLast &&
              css`
                border-top-left-radius: 0;
              `}
              ${!isLast &&
              css`
                border-bottom-left-radius: 0;
              `}
            }
          `
        }

        ${
          !isFirst &&
          !isLast &&
          css`
            // in the middle of other fields (above/below)
            border-radius: 0;
          `
        }

        ${
          isLast &&
          css`
            border-top-left-radius: 0;
            border-top-right-radius: 0;
          `
        }

        ${
          !isLast &&
          css`
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom: 0 none;
          `
        }

      `
    }

    ${
      hasError &&
      css`
        outline: 1px solid ${theme.colors.Danger};
      `
    }
  `}
`;
